import { TOTAL_PRICE_WRAPPER, TOTAL_PRICE_WRAPPERV2 } from "@/config";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import useStore from "./useStore";
import formatCurrency from "@/utils/formatCurrency";

const priceElement =
    document.querySelector(`.${TOTAL_PRICE_WRAPPER} > *`) ||
    document.querySelector(`${TOTAL_PRICE_WRAPPERV2} > *`);
let initialPrice = -1;

if (priceElement !== null) {
    let priceText = priceElement.textContent ?? "0";

    // Remove all non-numeric characters except comma and dot
    priceText = priceText.replace(/[^\d.,]/g, "");

    // Find the last comma and dot in the string
    const lastComma = priceText.lastIndexOf(",");
    const lastDot = priceText.lastIndexOf(".");

    if (lastComma > lastDot && priceText.length - lastComma === 3) {
        // If the comma is the last separator and there are 2 digits after it, treat it as the decimal separator
        priceText = priceText.replace(/\./g, ""); // Remove all dots (thousands separators)
        priceText = priceText.replace(",", "."); // Convert comma to dot for decimal
    } else if (lastDot > lastComma && priceText.length - lastDot === 3) {
        // If the dot is the last separator and there are 2 digits after it, treat it as the decimal separator
        priceText = priceText.replace(/,/g, ""); // Remove all commas (thousands separators)
    } else {
        // No decimal point, treat as whole number and remove all separators
        priceText = priceText.replace(/[.,]/g, "");
    }

    // Convert cleaned price string to a floating-point number
    initialPrice = parseFloat(priceText) || 0;
} else {
    initialPrice = 0;
    console.error("Could not find inital price");
}

export default function usePrices() {
    const {
        computed: { selectedDiamond }
    } = useStore();

    const diamondPrice = computed(() => {
        // ToDo: Workaround for exchange rate
        //@ts-expect-error Global not defined
        const currencyRate = parseFloat(window.Shopify?.currency?.rate ?? "1");

        // ToDo: Workaround for US markets rate
        //@ts-expect-error Global not defined
        const multiplier = window.Shopify?.country === "US" ? 1.1 : 1;

        return selectedDiamond.value
            ? (selectedDiamond.value.price * currencyRate * multiplier) / 100
            : 0;
    });
    const totalPrice = computed(() => initialPrice + diamondPrice.value);

    const ringbandPriceFormatted = computed(() => formatCurrency(initialPrice));

    const diamondPriceFormatted = computed(() =>
        formatCurrency(diamondPrice.value)
    );

    const totalPriceFormatted = computed(() =>
        formatCurrency(totalPrice.value)
    );

    return {
        priceElement,
        ringbandPrice: initialPrice,
        ringbandPriceFormatted,
        diamondPrice,
        diamondPriceFormatted,
        totalPrice,
        totalPriceFormatted
    };
}
